<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'《新仙剑奇侠传之挥剑问情》手游下载'"></div>
    <div :class="'down-bank-page page-'  + pageShow">
      <div class="header-container">
        <div class="game-icon"></div>
        <div class="title-container">
          <div class="fir-title">新仙剑奇侠传之挥剑问情</div>
          <div class="sec-title">仙剑剧情冒险卡牌手游</div>
        </div>
        <div class="official-btn"><a @click="openOfficial()" href="javascript:;"></a></div>
      </div>
      <div :class="'main main-' + typeOs">
        <div class="title"></div>
        <div :class="'download-box download-box-' + is_status">
          <a class="download-btn ios-btn" href="javascript:;" @click="openLogin('ios')"></a>
          <a class="download-btn and-btn" href="javascript:;" @click="openLogin('android')"></a>
          <a class="share-btn" href="javascript:;" @click="openShare()"></a>
        </div>
        <div class="description">
          <div></div>
        </div>
      </div>
      <!-- 公共底部 -->
      <Footer/>
    </div>

    <!-- 分享相关DOM -->
    <div :class="'share-box share-box-' + pageShow" ref="imageDom" >
      <img src="https://download4.qcplay.com/h5-images/active/hjwq/bank/code_img.png"/>
      <div class="share-img">
        <div class="qrcode-box">
          <div id="qrcode" class="qrcode"></div>
        </div>
      </div>
    </div>

    <!-- 分享弹窗 -->
    <div class="share-popup popup_wrap" v-show="shareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="share-box-2 popup_wrap-box" v-show="shareShow">
          <img :src="shareImg">
          <div class="close-btn" @click="shareClose()"></div>
          <div class="bottom-btn">
            <a id="my-code" href="javascript:;"  @click="onCopy('#my-code')" :data-clipboard-text='"《新仙剑奇侠传之挥剑问情》邀您重温经典："+urlCode'></a>
            <span :class="'tip-' + typeOs"></span>
          </div>
        </div>
      </transition>
    </div>

    <!-- 登录弹窗 -->
    <div :class="'login-popup popup_wrap login-popup-' + typeOs" v-show="loginShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="login-box popup_wrap-box" v-show="loginShow">
          <div class="register-box">
            <div class="close-btn" @click="closeLogin()"></div>
            <div class="tab-bar">
              <a href="javascript:;">短信登录</a>
            </div>
            <div class="form">
              <div class="sms_login">
                <div class="phone">
                  <label for="">
                    <i></i>
                    <input 
                      type="text" 
                      maxlength="18"
                      placeholder="请输入手机号"
                      v-model="inputData.account"
                    >
                  </label>
                </div>
                <div class="verify-code">
                  <label for="">
                    <i></i>
                    <input
                      type="text"
                      maxlength="6"
                      placeholder="请输入验证码"
                      v-model="inputData.sms_code"
                    >
                    <div class="timer" @click="getCode" :disabled="disabled">
                      {{ countdown }}
                      <b v-show="timestatus">秒</b>
                    </div>
                  </label>
                </div>
                <div class="btn" @click="loginData()"></div>
            </div>
            </div>            
          </div>
        </div>
      </transition>
    </div>

    <!-- 微信提示弹窗 -->
    <div class="download-wrap" v-show="downloadShow" @click="downloadShow = false"></div>

    <!-- 提示弹窗 -->
    <div :class="'tips-wrap tips-wrap-' + tipsShow">
      <div :class="'show-' + tipsShow2"><p>{{ tips }}</p></div>
    </div>
  </div>
</template>
<script>

import Footer from '../../../../components/BankFooter';
import { Indicator } from 'mint-ui';
import Clipboard from 'clipboard';
import { OnGetInitDataAPI, GetCodeAPI } from '../api';
import { analysisParams, monitoringOs, buriedLogger } from '@/utils/utils';
import { LoginDataAPI } from '../api';
import { generateQRCode, generateCanvasImage } from '@/utils/share';
export default {
  components: {
    Footer
  },
  data () {
    return {
      promptShow: false,
      shareShow: false,
      pageShow: false,
      loginShow: false,
      downloadShow: false,
      params: '',
      urlCode: '',
      shareImg: 'https://download4.qcplay.com/h5-images/active/hjwq/bank/code_img.png',
      is_shareImg: '',
      // api获取的数据
      inputData: {
        account: '',
        sms_code: '',
        os: '',
        code: '',
        bank_name: ''
      },
      is_code: '',
      is_bank_name: '',
      is_record: false,
      downloadUrl: '',
      typeOs: '',
      is_status: 1,
      // 倒计时
      disabled: false, //  发送验证码是否可点击
      countdown: '发送验证码', //  获取验证码
      timestatus: false, //  是否显示秒
      clear: null, // 清除定时器

      // 提示弹窗
      tips: '', // 提示语
      tipsShow: false,  // 提示显示1
      tipsShow2: false, // 提示显示2
    };
  },
  mounted () {
    this.$nextTick(() => {
      this.pageShowTimes();
      this.monitoringEquipment();
      setTimeout(() => {
        OnGetInitDataAPI().then(response => {
          if (Number(response.code) == 200) {
            this.is_status = response.data.is_status;
          }
        });
      }, 200); 

      // 埋点
      const bl = buriedLogger('hjwq', 'bank_download_page');
      this.logger = bl;

      setTimeout(() => {
        this.logger.sum('银行挑战赛h5_下载页统计');
      }, 200); 
    })
  },
  methods: {
    // 页面淡出显示
    pageShowTimes() {
      setTimeout(() => {
        this.pageShow = true;
      }, 200)
    },
    monitoringEquipment() {
      this.wxTips();
      setTimeout(() => {
        this.urlCode = window.location.href;
        // 获取哈希的参数
        this.params = analysisParams(window.location.href);
        this.is_code = this.params.code;
        this.is_bank_name = this.params.name;
        // 当前设备
        this.typeOs = monitoringOs();
        
        // 二维码生成
        this.qrcode(this.urlCode);
        this.$nextTick(() => {
          this.generateShareImage();
        });
      }, 200)
    },
    // 微信提示
    wxTips() {
      if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
        this.downloadShow = true;
      }
    },
    // 开启登录 & 下载
    openLogin(os) {
      if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
        this.downloadShow = true;
        return
      }
      this.loginShow = true;
      this.inputData.os = os;
    },
    // 开启提示弹窗
    openShare() {
      this.shareImg = this.is_shareImg;
      this.shareShow = true;
      this.logger.sum('银行挑战赛h5_点击分享游戏按钮');
    },
    // 关闭分享弹窗
    shareClose() {
      this.shareImg = '';
      this.shareShow = false;
    },
    // 分享图片设置
    generateShareImage () {
      Indicator.open();
      generateCanvasImage(this.$refs.imageDom)
      .then((canvas) => {
        Indicator.close();
        this.is_shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
        console.log('success: 图片生成成功');
      })
      .catch((err) => {
        Indicator.close();
        console.log('err: 图片生成失败', err.message);
      });
    },
    // 二维码生成
    qrcode (link) {
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        colorDark: '#faf2de',
        colorLight: '#d6605e'
      });
    },
    // 复制链接
    onCopy (my_id) {
      const clipboard = new Clipboard(my_id);
      clipboard.on('success', (e) => {
        this.tipsMessage('复制成功', 1000);
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        this.tipsMessage('复制失败', 1000);
      });
      this.logger.sum('银行挑战赛h5_复制链接按钮');
    },
    // 打开官网
    openOfficial() {
      this.logger.sum('银行挑战赛h5_点击官网按钮');
      this.tipsMessage('正在前往...', 2000);
      setTimeout(() => {
        window.location.href = 'https://hjwq.qingcijoy.com';
      }, 1000)
    },
    // 获取验证码
    getCode () {
      if (!/^1[3456789]\d{9}$/.test(this.inputData.account)) {
        return this.tipsMessage('请输入正确的手机号码', 2000);
      }      
      if(this.timestatus) return // 防抖
      GetCodeAPI({
        mobile: this.inputData.account,
        channel: 'login'
      }).then((response) => {
        if (response.code === 200) {
          this.timestatus = true;
          this.disabled = true; // 禁用点击
          this.countdown = 60;
          this.clear = setInterval(this.countDown, 1000);
        }
      });
    },
    // 倒计时
    countDown () {
      const that = this;
      if (!that.countdown) {
        that.disabled = false;
        that.timestatus = false;
        that.countdown = '发送验证码';
        clearInterval(that.clear);
      } else {
        --that.countdown;
      }
    },
    // 关闭登录
    closeLogin() {
      this.loginShow = false;
      this.inputData.account = '';
      this.inputData.sms_code = '';
    },
    // 登录信息收集
    loginData() {
      if (!/^1[3456789]\d{9}$/.test(this.inputData.account)) {
        return this.tipsMessage('请输入正确的手机号码', 2000);
      }
      if(this.inputData.sms_code == "") {
        return this.tipsMessage('请输入验证码', 2000);
      }
      // 信息赋值
      this.inputData.code = this.is_code;
      this.inputData.bank_name = this.is_bank_name;
      LoginDataAPI({
        ...this.inputData
      }).then((response) => {
        if (response.code === 200) {
          this.is_record = true;
          this.loginShow = false;
          this.logger.sum('银行挑战赛h5_' + this.inputData.os + '登记成功的收集统计');
          if(response.data.uri == '') {
            return this.tipsMessage('敬请期待！', 2000);
          } else {
            window.location.href = response.data.uri;
            // this.downloadUrl = response.data.uri;
          }
          this.inputData.account = '';
          this.inputData.sms_code = '';
        }
        this.tipsMessage(response.message, 2000);
        Indicator.close();
      });
    },
    // TAG: 其他简易封装的方法
    tipsMessage (message, times) {
      this.tipsShow = true
      this.tips = message
      setTimeout(() => { this.tipsShow2 = true }, 100)
      setTimeout(() => { this.tipsShow2 = false }, times - 200)
      setTimeout(() => { this.tipsShow = false; this.tips = '';}, times)
    },
  }
};
</script>
<style lang="less" scoped>
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/bank/download/index.vue